/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DownloadService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * The random UUID grants access to an Excel attachment created from emailed report data without requiring a login.
     * @param uuid
     * @param prepare
     * @returns any
     * @throws ApiError
     */
    public downloadFile(
        uuid: string,
        prepare: boolean = false,
    ): CancelablePromise<({
        url: string;
    } | string)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/download/file/{uuid}',
            path: {
                'uuid': uuid,
            },
            query: {
                'prepare': prepare,
            },
        });
    }
}
